import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/Store/store";
import { SelectedUserIdProvider } from './SelectedUserIdContext';

// Suppress ResizeObserver loop error globally
const originalError = console.error;
const originalWarn = console.warn;

// Override console methods to suppress ResizeObserver errors
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  if (message.includes('ResizeObserver loop completed with undelivered notifications')) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  const message = args[0]?.toString() || '';
  if (message.includes('ResizeObserver loop completed with undelivered notifications')) {
    return;
  }
  originalWarn.apply(console, args);
};

// Global error handler for unhandled errors
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <SelectedUserIdProvider>
          <App />
        </SelectedUserIdProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
